import React, { lazy } from 'react';

// 公版机器人路由
const LoginForRobot = lazy(() => import('@/pages/robotForCommon/Login'));
const RobotHome = lazy(() => import('@/pages/robotForCommon/Home'));
const PsychologicalAIConsultantWithPrompt = lazy(() => import('@/pages/robotForCommon/PsychologicalAIConsultation/PsychologicalAIConsultantWithPrompt'));
const PsychologicalAIConsultant = lazy(() => import('@/pages/robotForCommon/PsychologicalAIConsultation'));
const PsychologicalAIEvaluation = lazy(() => import('@/pages/robotForCommon/PsychologicalAIConsultation/PsychologicalAIEvaluation'));
const PsychologicalAIHealth = lazy(() => import('@/pages/robotForCommon/PsychologicalAIConsultation/PsychologicalAIHealth'));
const ConsultationSummary = lazy(() => import('@/pages/robotForCommon/ConsultationSummary'));


const robotRoutes = [
  { path: '/robot-common/login', component: <LoginForRobot />, needInterceptor: false },
  { path: '/robot-common/home', component: <RobotHome />, needInterceptor: true },
  { path: '/robot-common/psychological-ai-consultant-with-prompt', component: <PsychologicalAIConsultantWithPrompt />, needInterceptor: true },
  { path: '/robot-common/psychological-ai-consultant', component: <PsychologicalAIConsultant />, needInterceptor: true },
  { path: '/robot-common/psychological-ai-health', component: <PsychologicalAIHealth />, needInterceptor: true },
  { path: '/robot-common/psychological-ai-evaluation', component: <PsychologicalAIEvaluation />, needInterceptor: true },
  { path: '/robot-common/consultation-summary', component: <ConsultationSummary />, needInterceptor: false },
];

export default robotRoutes;
